var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 6.66667V10M8.54168 4.58333H5.66669C4.26655 4.58333 3.56649 4.58333 3.03171 4.85582C2.5613 5.0955 2.17885 5.47795 1.93917 5.94836C1.66669 6.48314 1.66669 7.1832 1.66669 8.58333L1.66669 9.58333C1.66669 10.3599 1.66669 10.7482 1.79356 11.0545C1.96271 11.4629 2.28717 11.7873 2.69555 11.9565C3.00183 12.0833 3.39012 12.0833 4.16669 12.0833V15.625C4.16669 15.8185 4.16669 15.9152 4.17471 15.9967C4.25265 16.788 4.8787 17.414 5.66999 17.492C5.75148 17.5 5.84822 17.5 6.04169 17.5C6.23516 17.5 6.3319 17.5 6.41338 17.492C7.20468 17.414 7.83073 16.788 7.90866 15.9967C7.91669 15.9152 7.91669 15.8185 7.91669 15.625V12.0833H8.54169C10.0137 12.0833 11.8144 12.8724 13.2036 13.6297C14.014 14.0715 14.4193 14.2924 14.6847 14.2599C14.9308 14.2297 15.1169 14.1192 15.2611 13.9176C15.4167 13.7001 15.4167 13.265 15.4167 12.3948V4.2719C15.4167 3.40166 15.4167 2.96654 15.2611 2.74907C15.1169 2.54742 14.9308 2.43692 14.6847 2.40677C14.4193 2.37427 14.014 2.59516 13.2036 3.03696C11.8144 3.79426 10.0137 4.58333 8.54168 4.58333Z",
    stroke: "#FAFEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementColor);
export default __webpack_public_path__ + "static/media/Announcement_Color.ea1eb5ecf51e4bb2fcb2063e836add20.svg";
export { ForwardRef as ReactComponent };